import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { CheckBox, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Borrower = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const isNoRelationship = useWatch({
    control,
    name: `subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.noRelationship`
  })

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.borrower`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          input={(props) => <CheckBox {...props} checkBoxLabel="f. Borrower" disabled={isNoRelationship} />}
          errorPosition="right"
        />
      )}
    />
  )
}
